import { useEffect, useState } from "react";
import { API } from "../../../utils/api";

// Admin filter helper — pulls a flat list of spots to populate a dropdown.
// Limit is generous (100) since this is a single-select picker; users can
// filter further via search if/when we wire one up later.
const useSpotsOptions = (enabled = true) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!enabled) return;
    API.getAdminSpots({ page: 1, limit: 100 })
      .then((res) => {
        if (res && res.type === "success" && Array.isArray(res.data)) {
          setOptions(
            res.data.map((s) => ({
              id: s.id,
              label: s.name || s.address || s.id,
            })),
          );
        }
      })
      .catch(() => {});
  }, [enabled]);

  return options;
};

export default useSpotsOptions;
